import { Card, Typography } from '@mui/material'
import { Avatar, Space, Table, TableColumnsType } from 'antd'

import { numberFormat } from '../../../../../utils'
import { ILineItemRow } from '../utils'

interface Props {
  items: ILineItemRow[]
}

const OrderLineItemsTable = ({ items }: Props) => {
  const columns: TableColumnsType<ILineItemRow> = [
    {
      title: 'สินค้า',
      key: 'product',
      render: (_, record) => (
        <Space>
          <Avatar shape="square" size={44} src={record.sku_image} />
          <Space direction="vertical" size={0}>
            <span>{record.product_name}</span>
            <Typography variant="caption" color="text.secondary">
              {record.sku_name}
              {record.seller_sku ? ` · ${record.seller_sku}` : ''}
            </Typography>
          </Space>
        </Space>
      ),
    },
    {
      title: 'ราคา/ชิ้น (฿)',
      dataIndex: 'unit_price',
      key: 'unit_price',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
    {
      title: 'รวม (฿)',
      dataIndex: 'subtotal',
      key: 'subtotal',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'ทุน/ชิ้น (฿)',
      dataIndex: 'unit_cost',
      key: 'unit_cost',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
    {
      title: 'รวมทุน (฿)',
      dataIndex: 'cost',
      key: 'cost',
      align: 'right',
      render: (value: number) => numberFormat(value),
    },
  ]

  return (
    <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        รายการสินค้า
      </Typography>
      <Table
        rowKey="key"
        columns={columns}
        dataSource={items}
        pagination={false}
        size="small"
        scroll={{ x: 'max-content' }}
      />
    </Card>
  )
}

export default OrderLineItemsTable
